<template>
   <nav class="navbar navbar-fixed-top">
      <div class="container-fluid">
         <div class="navbar-left">
            <div class="navbar-btn">
               <a href="javascript:;"><img src="@/assets/images/icon.png" alt="Mooli Logo" class="img-fluid logo"></a>
               <button type="button" class="btn-toggle-offcanvas"><i class="far fa-bars"></i></button>
            </div>
            <form id="navbar-search" class="navbar-form search-form weight-600 font-16">
               <i class="fa fa-home color-theme mr-2"></i><i class="fa fa-angle-right mr-2"></i>
               <span class="color-theme">{{ $route.name != null ? $route.name.replace(/_/g, " ").replace(/-/g, "/") : '' }}</span>
            </form>
         </div>
         <div class="navbar-right">
            <div id="navbar-menu">
               <ul class="nav navbar-nav">
                  <!-- <li v-if="dadosUsuario.usuarioPermissoes.includes('Ver Alertas')">
                     <router-link to="/alertas" class="icon-menu" role="button" title="Alertas">
                        <i class="fa-bell" :class="$route.path == '/alertas' ? 'fas' : 'fal'"></i>
                        <span class="notification-dot info" v-if="listaAlertas == null || listaAlertas.length > 0">{{ listaAlertas.length }}</span>
                     </router-link>
                  </li> -->
                  <li class="hidden-xs" id="geral_step3"><a href="javascript:void(0);" id="btnFullscreen" class="icon-menu"><i class="far fa-arrows-alt"></i></a></li>
                  <li><a href="javascript:;" class="icon-menu" @click="deslogar"><i class="far fa-sign-out"></i></a></li>
               </ul>
            </div>
         </div>
         <div class="recent_searche" style="display: none;">
            <div class="card mb-0">
               <div class="header">
                  <h2>Recent search result</h2>
                  <ul class="header-dropdown dropdown">
                     <li><a href="javascript:void(0);">Clear data</a></li>
                     <li><a href="javascript:;"><i class="fa fa-external-link"></i></a></li>
                  </ul>
               </div>
               <div class="body">
                  <ul class="list-group list-group-flush">
                     <li class="list-group-item p-l-0 p-r-0">
                        <h6><a href="#">Crush it - Bootstrap Admin Application Template &amp; Ui Kit</a></h6>
                        <p class="text-muted">It is a long established fact that a reader will be distracted.</p>
                        <div class="text-muted font-13">
                           <ul class="list-inline">
                              <li class="list-inline-item"><span class="badge badge-secondary margin-0">React</span></li>
                              <li class="list-inline-item">Dec 27 2020</li>
                           </ul>
                        </div>
                     </li>
                     <li class="list-group-item p-l-0 p-r-0">
                        <h6><a href="#">Epic Pro - HR &amp; Project Management Admin Template and UI Kit</a></h6>
                        <p class="text-muted">he point of using Lorem Ipsum is that it has a more-or-less English.</p>
                        <div class="text-muted font-13">
                           <ul class="list-inline">
                              <li class="list-inline-item"><span class="badge badge-success margin-0">HTML</span></li>
                              <li class="list-inline-item">Oct 13 2020</li>
                           </ul>
                        </div>
                     </li>
                     <li class="list-group-item p-l-0 p-r-0">
                        <h6><a href="#">Qubes - Responsive Admin Dashboard Template</a></h6>
                        <p class="text-muted">Commodo excepteur non ut aliqua ex qui velit sed esse consequat in </p>
                        <div class="text-muted font-13">
                           <ul class="list-inline">
                              <li class="list-inline-item"><span class="badge badge-danger margin-0">Bootstrap</span></li>
                              <li class="list-inline-item">Sep 27 2020</li>
                           </ul>
                        </div>
                     </li>
                  </ul>
               </div>
            </div>
         </div>
      </div>
   </nav>
</template>

<script>

import { mapState } from 'vuex'

export default {
	name: 'MenuNavBar',
   computed: {
      ... mapState({
         listaAlertas: state => state.listaAlertas,
         dadosUsuario: state => state.dadosUsuario,
         tokenSessao: state => state.tokenSessao,
         isLogado: state => state.isLogado,
         urlRest: state => state.urlRest
      })
   },
   methods: {
      imageError : function (e) {
         this.$store.dispatch('imageError', e)
      },
		deslogar : function () {
			this.$store.dispatch('deslogar')
      }
   }
}

</script>